<template>
  <!-- 直播间列表 -->
  <!-- <el-card shadow="always" style="position: relative;"> -->
  <div shadow="always" style=" ">
    <!-- <img class="card-img" v-if="aloneData.istop == 1 && lan == 'ch'" src="../../../assets/icon-recommend.png" alt="">
    <img class="card-img" v-if="aloneData.istop == 1 && lan == 'en'" src="../../../assets/icon-recommend-en.png" alt=""> -->
    <div class="job-info" v-for="(item, index) in aloneData.jobList" v-if="item.classify==showJobId">
      <div class="job-details-title">{{item.jobc_super_name}}•{{item.name}}岗位任职介绍<div class="bottom-line"></div></div>
      <div class="job-info-item" style="color: #0373fe;">岗位薪资：{{item.salary}}</div>
      <div class="job-info-item">工作所在地：{{item.city}}</div>
      <div class="job-details">{{item.details}}</div>
    </div>
    <div class="alone_content" style="padding: 25px;">
      <div class="alone_left" >
        <div style="border: 1px solid #d9d9d9;padding: 10px;height: 81px;line-height: 79px;">
          <img
              v-if="aloneData.broadcast_logo"
              style="width:98%;max-width:170px; height: auto;object-fit: cover;object-position: top;"
              :src="aloneData.broadcast_logo"
          />
          <img
              v-else
              style="width:100%;max-width:170px; height: auto;object-fit: cover;object-position: top;"
              src="../../../assets/img_default_logo.png"
          />
        </div>
      </div>
      <div class="alone_right">
        <div v-if="lan == 'ch'">
          <div class="always_main_title">{{ aloneData.broadcast_name }}</div>
          <div class="broadcast_information">
            <!-- <div class="info_col">{{aloneData.location}} - {{aloneData.company}}</div> -->
            <div style="min-width: 200px;text-align: left;margin-top: 4px;">
              {{ aloneData.user_post }}: {{ aloneData.truename }}
            </div>
            <div style="margin-left: 0px;text-align:left; " v-if="token != null && token != undefined && userNature == '1' && aloneData.exh_status == 3">
<!--              {{ aloneData.broadcast_class_name }}-->
              邮箱：
              <span v-if="parseInt(emailHidden) > 0">{{aloneData.email}}</span>
              <el-button
                  type="text"
                  style="height: 40px;padding-top: 0;border: none;height: 0;"
                  @click="handleInfo(stateEnum.SEE_CONTACT)"
                  v-else
              >{{ language.seeContact }}</el-button>

            </div>
          </div>
        </div>
<!--        <div v-if="lan == 'en'">-->
<!--          <div class="always_main_title">{{ aloneData.broadcast_name_en }}</div>-->
<!--          <div class="broadcast_information">-->
<!--            &lt;!&ndash; <div class="info_col">{{aloneData.location_en}} - {{aloneData.company_en}}</div> &ndash;&gt;-->
<!--            <div style="min-width: 200px;text-align: left;">-->
<!--              {{ aloneData.user_post_en }}: {{ aloneData.truename_en }}-->
<!--            </div>-->
<!--            <div style="margin-left: 0px;text-align:left;">-->
<!--              {{ aloneData.broadcast_class_name_en }}-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
        <div class="profile">
          <!-- <p style="opacity: 0;" ref="more">占位</p> -->

          <div
            style="width:930px;margin-top: 20px;display: flex"
            ref="profileSpan"
            class="ellipsis-p"
            v-if="lan == 'ch'"
          >
<!--            业务关键字: {{ aloneData.keyword }}-->
            <div style="flex: 1;">
              <img src="../../../assets/img/02.png" style="position: relative;top: 3px;height: 16px;">
              招聘职位:
            </div>
            <div style="flex: 10;">
              <el-button class="postBtn"  round size="mini" style="padding: 3px 8px 3px 14px;margin-left: 10px;font-size: 14px;margin-bottom: 10px;" :style="item.classify==showJobId?'background-color: #f47900;':''" @click="jobItemClick(item)"
                         v-for="(item, index) in aloneData.jobList" v-if="item.id"
              >{{item.jobc_super_name}}•{{ item.name }}<i class="el-icon-arrow-right el-icon--right" style="margin-left: 0px;"></i></el-button>
            </div>

          </div>
<!--          <p-->
<!--            style="width:930px;"-->
<!--            ref="profileSpan"-->
<!--            class="ellipsis-p"-->
<!--            v-if="lan == 'en'"-->
<!--          >-->
<!--            Business Key Words: {{ aloneData.keyword_en }}-->
<!--          </p>-->
          <!-- <div v-if="showBtn==true">
            <div class="btn-div" v-if="showBtnShow == false" @click="changeShowBtn(1)">
              <span v-if="lan=='ch'">展开</span>
              <span v-else>open</span>
              <img src="../../../assets/icon_develop.png" alt="">
            </div>
            <div class="btn-div" v-else  @click="changeShowBtn(0)">
              <span v-if="lan=='ch'">收起</span>
              <span v-else>close</span>
              <img src="../../../assets/icon_retract.png" alt="">
            </div>
          </div> -->
        </div>
        <div class="alone_btn">
          <!-- <div class="people_number">
            {{language.alreadyHave}}{{ aloneData.subscribe_count }} {{ language.newAhead }}
            {{language.peopleNumText.replace('{0}', aloneData.queue_count)}}
          </div> -->
          <div
            style="margin-left: -300px;"
            v-if="
              token &&
                aloneData.broadcast_state != 2 &&
                aloneData.broadcast_state != 0 &&
                aloneData.is_wait != 0 &&
                aloneData.to_wait != 0 &&
                aloneData.wait_num != 0
            "
          >
            <!-- <div class="people_number1" v-if="lan =='en' && aloneData.exhibitionState != 3 && aloneData.broadcast_state ==1 && aloneData.list_state >= 1">{{aloneData.wait_num}} people waiting in line before you. Please wait</div> -->
            <!-- <div class="people_number1" v-if="lan =='ch'&& aloneData.exhibitionState != 3 && aloneData.broadcast_state ==1 && aloneData.list_state >= 1">当前有{{aloneData.wait_num}}人排队</div> -->
            <!--            <div class="people_number1" v-if="lan =='ch'">There are currently {{aloneData.wait_num}} people in line</div>-->
          </div>
        </div>
        <!-- <div class="alone_btn" v-if="paramsIndex == 'index' && !token">
        </div> -->
        <div class="alone_btn">
          <div class="talk_btn">
            <!-- 我要洽谈 -->
            <!-- <el-button
              type="warning"
              style="height: 40px;width: 150px;float: left"
              v-if="ExhibitionTypeEnum.ONGOING == exhState"
              @click="handleInfo(stateEnum.JOIN_DISCUSS)"
            >
              {{language.talkBtn}}
            </el-button> -->

            <el-button
              type="warning"
              style="height: 35px;line-height: 8px;width: 110px;float: left;background-color: #F47900;font-size: 16px;"
              v-if="
            aloneData.exh_status == 2 &&
            (aloneData.broadcast_state == 1|| aloneData.broadcast_state == 3 || aloneData.queue_count > 0) "
              @click="newHandleInfo(stateEnum.JOIN_DISCUSS)"
            >
            <!-- 欢迎洽谈 洽谈中-->
              <!-- {{ aloneData.audience_count > 0 ? language.InLine :language.newTalkBtn }} -->
              {{ (aloneData.broadcast_state == 3 || aloneData.queue_count > 0) ? language.InLine :language.newTalkBtn }}
            </el-button>
            <!-- 我要排队 -->
            <el-button
              type="warning"
              style="height: 35px;line-height: 8px;float: left;width: 110px;border: none;margin-right: 20px;font-size: 16px;background-color: #0071ff;"
              @click="newHandleInfo(stateEnum.JOIN_DISCUSS)"
              v-if="(aloneData.broadcast_state == 3 || aloneData.queue_count > 0) && !aloneData.is_queue"
            >
              {{language.lineUp}}
            </el-button>
            <!-- 我已排队 -->
            <el-button
              type="warning"
              style="height: 35px;line-height: 8px;float: left;width: 110px;background: #FFFFFF;border: 1px solid #0071ff;margin-right: 20px;color: #0071ff;font-size: 16px;"
              v-if="(aloneData.broadcast_state == 3 || aloneData.queue_count > 0) && aloneData.is_queue"
            >
              {{language.lineUpOn}}
            </el-button>
            <!-- 未开始 -->

            <el-button
              type="warning"
              style="height: 35px;line-height: 8px;width: 110px;float: left;font-size: 16px;background-color: #b3d4fe;border: none;"
              v-if="
            aloneData.exh_status == 2 &&
            aloneData.broadcast_state != 1 && aloneData.broadcast_state != 3
            "
              @click="newHandleInfo(stateEnum.JOIN_DISCUSS)"
            >
              {{ language.NotStarted1 }}
            </el-button>

            <!-- 已结束 -->
            <!-- <el-button
              type="warning"
              style="height: 40px;width: 150px;float: left;background:grey;border:1px solid grey;"
              v-if="ExhibitionTypeEnum.ONGOING == exhState && aloneData.broadcast_state == 2"
            >
              {{language.Finished}}
            </el-button> -->
            <!-- 查看联系方式 -->
<!--            <el-button-->
<!--              type="text"-->
<!--              style="height: 40px;float: left"-->
<!--              v-if="aloneData.exh_status == 3"-->
<!--              @click="handleInfo(stateEnum.SEE_CONTACT)"-->
<!--              >{{ language.seeContact }}</el-button-->
<!--            >-->

            <!--预约-->
            <!-- <el-button
              type="warning"
              style="height: 35px;line-height: 8px;float: left;width: 150px;background-color: #0f408a;border: none;margin-right: 20px;background-color: #0f408a;"
              v-if=" aloneData.subscribe_type == 0 && (aloneData.exh_status == 1) "
              @click="toggelSubject(aloneData)"
            >
              {{language.ahead}}
            </el-button> -->


            <!-- 取消预约 -->
            <!-- <el-button
              type="warning"
              v-if=" aloneData.subscribe_type != 0 && (aloneData.exh_status == 1) "
              style="height: 35px;line-height: 8px;float: left;width: 150px;background-color: #0f408a;border: none;margin-right: 20px"
              @click="handleUnMake"
            >
              {{language.unfollow}}
            </el-button> -->
            <span style="line-height: 40px;padding-left: 10px;" v-if="aloneData.use_time&&aloneData.subscribe_type > 0">{{language.Booked}}：{{aloneData.use_time}}</span>


<!--            <el-button-->
<!--              type="warning"-->
<!--              style="height: 40px;float: left;width: 150px;background-color: #0f408a;border: none;margin-right: 20px"-->
<!--              v-if="-->
<!--              ExhibitionTypeEnum.HAS_ENDED != exhState-->
<!--              &&-->
<!--              ExhibitionTypeEnum.END_HAS_ENDED != exhState-->
<!--              && aloneData.privateTalk != 0-->
<!--              "-->
<!--            >-->
<!--              {{language.Booked}}-->
<!--            </el-button>-->






            <!--            <el-button-->
            <!--              type="warning"-->
            <!--              style="height: 40px;float: left;width: 150px;background-color: #0f408a;border: none;margin-right: 20px"-->
            <!--              v-if="-->
            <!--              ExhibitionTypeEnum.HAS_ENDED != exhState-->
            <!--              &&-->
            <!--              ExhibitionTypeEnum.END_HAS_ENDED != exhState-->
            <!--              && aloneData.privateTalk != 0-->
            <!--              "-->
            <!--            >-->
            <!--              {{language.Booked}}-->
            <!--            </el-button>-->

            <!--            <el-button-->
            <!--              type="warning"-->
            <!--              v-if="lan == 'ch' && ExhibitionTypeEnum.HAS_ENDED != exhState-->
            <!--              &&-->
            <!--              ExhibitionTypeEnum.END_HAS_ENDED != exhState"-->
            <!--              style="height: 40px;float: left;width: 150px;background-color: #0f408a;border: none;margin-right: 20px"-->
            <!--              @click="showImg"-->
            <!--            >-->
            <!--            邀请码分享-->
            <!--            </el-button>-->
            <!--            <el-button-->
            <!--              type="warning"-->
            <!--              v-if="ExhibitionTypeEnum.HAS_ENDED != exhState-->
            <!--              &&-->
            <!--              ExhibitionTypeEnum.END_HAS_ENDED != exhState"-->
            <!--              style="height: 40px;float: left;width: 150px;background-color: #0f408a;border: none;margin-right: 20px"-->
            <!--              @click="showPcUrl"-->
            <!--            >-->
            <!--              <span v-if="lan == 'ch'">分享链接</span>-->
            <!--              <span v-if="lan == 'en'">Share Link</span>-->
            <!--            </el-button>-->
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- </el-card> -->
</template>

<script>
import { ExhibitionTypeEnum } from "../../../common/constant/exhibition";
import errorImage from "../../../assets/error_room_new.png";
import { stateEnum } from "./enum";
import { mapGetters } from "vuex";
import {selectList} from "@/api/exhibition";

export default {
  computed: {
    ...mapGetters(["token"]),
  },
  props: {
    language: {
      type: Object,
      default: () => {},
    },
    paramsIndex: {
      type: String,
    },
    lan: {
      type: String,
    },
    k: {
      type: Number,
    },
    nowJobId: {
      type: [Number, String],
    },
    aloneData: {
      type: Object,
      default: () => {},
    },
    exhState: {},
    zpPost: {
      type: String,
    },
    emailHidden: {
      type:String,
      default:null,
    },
    userNature: {
      type:String,
      default:""
    },
    hiddenshow: {
      type:Boolean,
    }
  },
  watch : {
      nowJobId:function(val) {
        this.showJobId = val;
      },
    hiddenshow:function (val) {
      // console.log("弹框" ,this.hiddenshow);
      if(!this.hiddenshow){
        this.showJobId = this.nowJobId;
        // console.log("点击的岗位" ,this.showJobId);
      }
    }

  },
  data() {

    return {
      showSubject: false,
      ExhibitionTypeEnum,
      stateEnum:stateEnum,
      errorImage,
      showJobId:0,
      isMobileBool: true,
      showHint: false,
      showBtn: false,
      showBtnShow: false,
      subscribe_set: [],
      postClassfiy:this.aloneData.keyword ? this.aloneData.keyword.split(' ') : null,

    };
  },
  methods: {
    jobItemClick(item){
      console.log("公司信息==" , item);
      if(this.showJobId == item.classify){
        this.showJobId = '';
      }else{
        this.showJobId = item.classify;
      }

    },
    toggelSubject(item) {
      if(item.subscribe_start == '' || item.subscribe_end == '' ){
        this.$message({
          message: this.language.toggelSubjectMessage,
          type: "warning",
        });
      }else if (this.$store.state.user.token == null) {
        this.open();
      } else {
        this.$emit("newToggelSubject", {
          item: item,
          subindex: this.k,
        });
      }
      /*if (this.$store.state.user.token == null) {
        this.open();
      } else {
        //if(this.aloneData.subscribe_set){
        this.showSubject = true;
        this.$emit("newToggelSubject", {
          broadcast_id: item.broadcast_id,
          exhibition_id: item.exhibition_id,
          subindex: this.k,
        });
        //   }else{
        //     this.handleMake();
        //   }
      }*/
    },

    open() {
      let hint=this.language.hint;
      let login=this.language.login;
      let apply=this.language.apply;
      this.$confirm(this.language.promptMessage, hint, {
        confirmButtonText: login,
        cancelButtonText: apply,
        type: "warning",
      })
        .then(() => {
          location.href = "login.html#/";
        })
        .catch(() => {
          location.href = "register.html#/";
        });
    },
    handleInfo(stateInfo) {
      // this.$emit(
      //   "getLiveInfo",
      //   { state: stateInfo, id: this.aloneData.broadcast_id },
      //   this.aloneData.broadcast_id
      // );
      this.$emit(
        "getLiveInfo",
        { state: true});
    },
    // 新进入洽谈方法
    newHandleInfo(stateInfo) {
      // debugger;
      this.$emit(
        "newHandleInfo",
        { state: stateInfo, id: this.aloneData.broadcast_id },
        this.aloneData.broadcast_id
      );
    },
    // 线下预约
    handleOfflineAppointment() {
      //this.$emit("handleOfflineAppointment", this.aloneData)
    },
    //预约
    handleMake() {
      this.$emit("getLiveInfo", {
        state: this.stateEnum.SUBSCRIBE,
        id: this.aloneData.broadcast_id,
        k: this.k,
      });
    },
    //取消预约
    handleUnMake() {
      this.$emit("getLiveInfo", {
        state: this.stateEnum.CANCELSUB,
        id: this.aloneData.broadcast_id,
        k: this.k,
      });
    },
    // 邀请码分享
    showImg() {
      this.$emit("showImg", this.aloneData);
    },
    //分享链接
    showPcUrl() {
      this.$emit("showPcUrl", this.aloneData);
    },
    //判断手机浏览器
    isMobile() {
      if (
        navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        )
      ) {
        this.isMobileBool = false; // 手机端
      } else {
        this.isMobileBool = true; // alert('PC端')
      }
    },
    //显不显示展开按钮
    functionShowBtn() {
      // let pHeight = this.$refs.profileSpan.offsetHeight;
      // let moreHeight = Math.ceil(window.getComputedStyle(this.$refs.more).height.split('px')[0]) * 3;
      // // alert(this.isMobileBool)
      // if(this.isMobileBool) {
      //   this.$refs.profileSpan.style.maxHeight = moreHeight + 'px';
      // }else{
      //   this.$refs.profileSpan.style.height = moreHeight + 'px';
      //   this.$refs.profileSpan.style.maxHeight = '100%';
      // }
      // if(pHeight > moreHeight){
      //   this.showBtn = true;
      // }else{
      //   this.showBtn = false;
      // }
    },

    changeShowBtn(bool) {
      // let moreHeight = Math.ceil(window.getComputedStyle(this.$refs.more).height.split('px')[0]) * 3;
      //  if(this.isMobileBool == false) {
      //     if(bool == 0){
      //       this.showBtnShow = false;
      //       this.$refs.profileSpan.style.height = '100%';
      //       this.$refs.profileSpan.style.maxHeight = moreHeight + 'px';
      //       // console.log(this.showBtnShow);
      //     }else{
      //       this.showBtnShow = true;
      //       this.$refs.profileSpan.style.height = '100%';
      //       this.$refs.profileSpan.style.maxHeight = '100%';
      //     }
      //  }else{
      //     if(bool == 0){
      //       this.showBtnShow = false;
      //       this.$refs.profileSpan.style.height = '100%';
      //       this.$refs.profileSpan.style.maxHeight = moreHeight + 'px';
      //       // console.log(this.showBtnShow);
      //     }else{
      //       this.showBtnShow = true;
      //       this.$refs.profileSpan.style.maxHeight = '100%';
      //     }
      //  }
    },
  },
  mounted() {
    this.showJobId = this.nowJobId;
    this.functionShowBtn();
    // console.log("this.a=" + this.aloneData.keyword);
    // this.aloneData.exh_status = '3';
    console.log("this.a=" , this.aloneData);
    // console.log("数量==" + this.userNature);
    // console.log(this.$refs.profileSpan.offsetHeight)
    this.showJobId = this.nowJobId;
    console.log("岗位ID===" + this.nowJobId);
  },
  created() {
    this.isMobile();
  },
};
</script>

<style scoped>
.job-info{
  text-align: left;
  padding-left: 25px;
  padding-top: 25px;
}
.job-info-item{
  float: right;
  font-size: 18px;
  font-weight: bold;
  margin-left: 25px;
  color: #333333;
  margin-right: 25px;
}
.job-details-title{
  font-size: 20px;
  color: #333333;
  display: inline-block;
  position: relative;
  font-weight: bold;
}
.job-details{
  padding-top: 15px;
  margin-right: 25px;
  font-size: 14px;
  line-height: 24px;
  color: #333333;
  word-wrap:break-word;
  word-break:break-all;
  white-space: pre-wrap;
}
.job-info .bottom-line{
  height: 5px;
  background-color: #0071ff;
  opacity: 0.16;
  position: absolute;
  left: 0px;
  bottom: 0px;
  right:0px;
  z-index: 0;
}
.card-img {
  width: 50px;
  height: 50px;
  position: absolute;
  top: 0;
  left: 0;
}
.alone_content {
  padding: 0px 20px 0 20px;
  display: flex;
  display: -webkit-flex;
  flex-direction: row;
}
.alone_left {
  /*display: flex;*/
  flex-direction: column;
  display: -webkit-flex;
  align-items: center;
  overflow: hidden;
}
.alone_right {
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  margin-left: 20px;
  width: 930px;
}
.always_main_title {
  font-family: MicrosoftYaHei-Bold;
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  line-height: 17px;
  color: #333333;
  text-align: left;
}
.broadcast_information {
  display: flex;
  display: -webkit-flex;
  flex-direction: row;
  margin-top: 20px;
  font-size: 14px;
  color: #424242;
  font-weight: normal;
  font-stretch: normal;
  font-family: MicrosoftYaHei;
}
.profile {
  /* margin-top: 20px; */
  /* text-indent:2em; */
  /*margin-top: 20px;*/
  font-family: MicrosoftYaHeiLight;
  text-align: left;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 24px;
  letter-spacing: 0;
  color: #a1a1a1;
  word-wrap: break-word;
}
.info_col {
  max-width: 285px;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.people_number {
  color: #424242;
  font-size: 14px;
}
.alone_btn {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.btn-div {
  cursor: pointer;
  float: right;
  font-size: 14px;
  font-weight: 600;
  margin: 25px 0 25px;
  color: rgb(15, 64, 138);
}
.btn-div span {
  padding-top: 5px;
}
.btn-div img {
  width: 15px;
  height: 15px;
  vertical-align: middle;
  margin-left: 2px;
  /* margin-top: -5px; */
}
.ellipsis-p {
  width: 920px;
  /* overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical; */
  /* text-align: center; */
  /* position: relative; */
  line-height: 24px;
  max-height: 100%;
  /* overflow: hidden; */
}
.postBtn{
  background-color: #0071ff;
  color: #FFFFFF;
  border: none;
}
.postBtn1{
  background-color: #f47900;
  color: #FFFFFF;
  border: none;
}

/* .ellipsis-p::after {
      content: "...";
      position: absolute;
      bottom: 0;
      right: 0px;
      padding:0 30px 0 0px;
      background: -webkit-linear-gradient(left, transparent, #fff 40%);
      background: -o-linear-gradient(right, transparent, #fff 40%);
      background: -moz-linear-gradient(right, transparent, #fff 40%);
      background: linear-gradient(to right, transparent, #fff 40%);
  } */
.ellipsis-p-m {
  width: 985px;
  /* overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical; */

  position: relative;
  line-height: 24px;
  max-height: 100%;
  overflow: hidden;
}
.ellipsis-p-m::after {
  content: "...";
  position: absolute;
  bottom: 5px;
  right: 0px;
  padding: 0 30px 0 0px;
  margin-left: -10px;
  font-size: 24px;
  background: #fff;
  /* background: -webkit-linear-gradient(left, transparent, #fff 40%);
      background: -o-linear-gradient(right, transparent, #fff 40%);
      background: -moz-linear-gradient(right, transparent, #fff 40%);
      background: linear-gradient(to right, transparent, #fff 40%); */
}
.alone_btn {
  margin-top: 18px;
}
</style>
